{{ fieldValue | formatLongText: 30 }}
